import { AppPaths } from '@core/routes/routesPaths';
import { TimePeriodOptionsFn, TimePeriodType, RefreshButtonModel, SharedContextModel } from '@shared/models';
import { createContext, Dispatch } from 'react';

export const SharedReducerDefaultValues = {
  range: TimePeriodOptionsFn()[TimePeriodType.Week].range,
  pageContext: AppPaths.pressView.path.base,
  refreshButton: {
    show: false,
    disabled: true,
    onClick: () => {},
  },
  showAllocatedSites: true,
} as SharedContextModel;

export enum SharedActionType {
  SetRange = 'SetRange',
  SetPageContext = 'SetPageContext',
  SetRefreshButton = 'SetRefreshButton',
  SetShowAllocatedSites = 'SetShowAllocatedSites',
}

type State = SharedContextModel;
type Action = {
  type: SharedActionType;
  payload: [Date, Date] | string | RefreshButtonModel | boolean;
};

export const sharedReducer = (state: State, action: Action): State => {
  const { type, payload } = action;
  switch (type) {
    case SharedActionType.SetRange:
      return {
        ...state,
        range: payload as [Date, Date],
      };
    case SharedActionType.SetPageContext:
      return {
        ...state,
        pageContext: payload as string,
      };
    case SharedActionType.SetRefreshButton:
      return {
        ...state,
        refreshButton: payload as RefreshButtonModel,
      };
    case SharedActionType.SetShowAllocatedSites:
      return {
        ...state,
        showAllocatedSites: payload as boolean,
      };
    default:
      return state;
  }
};

export const SharedContext = createContext<{
  state?: State;
  dispatch?: Dispatch<Action>;
}>({});
